var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3164 20.7041H19.9985L20 14.1771C20 10.9729 19.3119 8.50986 15.58 8.50986C14.173 8.45745 12.8095 9.20141 12.0923 10.4318H12.0428V8.8058H8.50804V20.7037H12.1901V14.8179C12.1901 13.2658 12.4836 11.7626 14.4013 11.7626C16.2918 11.7626 16.3164 13.5386 16.3164 14.9183V20.7041ZM3.94995 7.63095C4.30138 7.86647 4.71453 7.99214 5.13714 7.99206C5.41775 7.99201 5.69558 7.9365 5.95481 7.82871C6.21403 7.72092 6.44958 7.56295 6.64796 7.36383C6.84634 7.16471 7.00367 6.92833 7.11101 6.66819C7.21835 6.40805 7.27357 6.12925 7.27352 5.8477C7.27345 5.42366 7.14805 5.00916 6.91319 4.65663C6.67834 4.3041 6.34458 4.02936 5.95411 3.86716C5.56364 3.70495 5.13401 3.66257 4.71953 3.74537C4.30505 3.82817 3.92436 4.03244 3.62558 4.33233C3.3268 4.63223 3.12335 5.01428 3.04098 5.43019C2.95861 5.8461 3.00101 6.27717 3.16281 6.6689C3.3246 7.06063 3.59852 7.39543 3.94995 7.63095ZM3.29226 20.7041H6.97818V8.8058H3.29226V20.7041Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.f05bd3c1a2a4373568b52d5d7ecb1ea4.svg";
export { ForwardRef as ReactComponent };